
import WidgetDefaultNuxt from '../default/nuxt.vue';
import { debounce } from '@/libs/utils.js';
// import debounce from 'lodash/debounce';

export default {
  name: 'WidgetCdkeyNuxt',
  extends: WidgetDefaultNuxt,
  data() {
    const cdkeyInfo = this.values.cdkey;
    const characterValue = cdkeyInfo.characterIDInput.label;
    const giftCodeValue = cdkeyInfo.giftCodeInput.label;
    const captchaCodeValue = cdkeyInfo.captchaCodeInput.label;
    const submitTextValue = cdkeyInfo.submitText;
    const errorCodesValue = cdkeyInfo.errorCodeLabels;
    let errorCodeLabels_temp = {};
    Object.keys(errorCodesValue).forEach((key) => {
      errorCodeLabels_temp[key] = this.getLocaleValue(errorCodesValue[key]);
    });
    const popupConfirmValue = cdkeyInfo.popupConfirm;
    let popupConfirmLabel_temp = {};
    Object.keys(popupConfirmValue).forEach((key) => {
      popupConfirmLabel_temp[key] = this.getLocaleValue(popupConfirmValue[key]);
    });

    return {
      characterIDValue: '',
      giftCodeValue: '',
      captchaCodeValue: '',
      cdKeyParmas: {
        activity_code: '',
        character_id: '',
        gift_code: '',
        verify_captcha_key: '',
        verify_captcha_code: '',
        lang: '',
      },
      errors: {
        character_id: '',
        gift_code: '',
        verify_captcha_code: '',
      },
      captchaLock: false,
      captchaImg: '',
      roleName: '',
      errorCodeLabels: errorCodeLabels_temp,
      popupConfirmLabel: popupConfirmLabel_temp,

      characterLabel: this.getLocaleValue(characterValue),
      giftCodeLabel: this.getLocaleValue(giftCodeValue),
      captchaCodeLabel: this.getLocaleValue(captchaCodeValue),
      submitTextLabel: this.getLocaleValue(submitTextValue),

      showPopupConfirm: false,
    };
  },
  computed: {
    cdkeyInfo() {
      return this.values.cdkey;
    },
    characterIDInput() {
      return this.cdkeyInfo.characterIDInput;
    },
    giftCodeInput() {
      return this.cdkeyInfo.giftCodeInput;
    },
    captchaCodeInput() {
      return this.cdkeyInfo.captchaCodeInput;
    },
  },
  watch: {
    characterIDValue() {
      this.errors.character_id = '';
      debounce(this.getNick(), 800);
    },
    giftCodeValue() {
      this.errors.gift_code = '';
    },
    captchaCodeValue() {
      this.errors.verify_captcha_code = '';
    },
  },
  mounted() {
    this.initCdkeyData();
  },
  methods: {
    initCdkeyData() {
      const cdkeyInfo = this.values.cdkey;
      this.cdKeyParmas = {
        server_code: cdkeyInfo.serverCode,
        character_id: cdkeyInfo.characterIDInput.value,
        gift_code: '',
        verify_captcha_key: '',
        verify_captcha_code: '',
      };
      this.characterIDValue = cdkeyInfo.characterIDInput.value;
      this.giftCodeValue = cdkeyInfo.giftCodeInput.value;
      this.captchaCodeValue = cdkeyInfo.captchaCodeInput.value;

      const extractText = cdkeyInfo.extractText;
      const extractTextList = extractText.split(',');
      for (const item of extractTextList) {
        const [key, value] = item.split(':');
        const urlValue = this.$route.query[value];
        if (urlValue) {
          this.cdKeyParmas[key] = urlValue;
          if (key === 'character_id') {
            this.characterIDValue = urlValue;
          }
        }
      }
    },
    checkValidity() {
      let error = true;
      for (const key of Object.keys(this.errors)) {
        if (this.cdKeyParmas[key] === '' || this.cdKeyParmas[key].length < 1) {
          this.errors[key] = ' ';
          error = false;
        }
      }
      return error;
    },
    inputClick() {
      if (this.cdKeyParmas.verify_captcha_key === '') {
        this.getCaptcha();
      }
    },
    getCaptcha() {
      if (this.captchaLock) return;
      this.captchaLock = true;
      const { captchaApi } = this.cdkeyInfo;
      setTimeout(() => {
        this.$axios
          .$get(captchaApi)
          .then((res) => {
            this.cdKeyParmas.verify_captcha_key = res.key;
            this.captchaImg = res.img;
          })
          .finally(() => {
            this.captchaLock = false;
          });
      }, 500);
    },
    onSubmit() {
      this.showPopupConfirm = false;

      this.cdKeyParmas.character_id = this.characterIDValue;
      this.cdKeyParmas.gift_code = this.giftCodeValue;

      // console.log(window.moo.code, this.cdKeyParmas.gift_code.length);
      // if (
      //   ('NEtyGovLFYJN' === window.moo.code ||
      //     'NALLwu52KQFI' === window.moo.code) &&
      //   this.cdKeyParmas.gift_code.length === 13
      // ) {
      //   const hasLowerCase = /[a-z]/.test(this.cdKeyParmas.gift_code);
      //   if (!hasLowerCase) {
      //     this.cdKeyParmas.gift_code = this.cdKeyParmas.gift_code.toLowerCase();
      //   }
      //   console.log(this.cdKeyParmas.gift_code);
      // }
      this.cdKeyParmas.verify_captcha_code = this.captchaCodeValue;

      this.errors = {
        character_id: '',
        gift_code: '',
        verify_captcha_code: '',
      };
      this.$nextTick(() => {
        if (!this.checkValidity()) return;
        const { submitSuccessId, activityApi } = this.cdkeyInfo;
        this.$axios
          .$post(activityApi, this.cdKeyParmas)
          .then((res) => {
            // console.log(res);
            const errorCode = res.error;
            if (errorCode) {
              let msg = this.errorCodeLabels[errorCode] || res.message;
              window.moo.$bus.$emit('rocket:ui:showToast', 'text', msg, 3);
              if (errorCode === 100004) {
                this.getCaptcha();
                this.errors.verify_captcha_code = ' ';
              } else if (errorCode === 100002) {
                this.errors.character_id = ' ';
              } else if (errorCode === 100016) {
                this.errors.gift_code = ' ';
              }
            } else if (submitSuccessId) {
              this.$bus.$emit('rocket:system:jumpPage', {
                key: submitSuccessId,
              });
            }
          })
          .finally(() => {
            // console.log('finally');
          })
          .catch((err) => {
            // console.log('catch res', err);
            let data = err.response.data;
            const errorCode = data.error;
            let msg = this.errorCodeLabels[errorCode] || data.message;
            if (errorCode === 100004) {
              this.getCaptcha();
              this.errors.verify_captcha_code = ' ';
            } else if (errorCode === 100002) {
              this.errors.character_id = ' ';
            } else if (errorCode === 100016) {
              this.errors.gift_code = ' ';
            }
            if (msg) {
              window.moo.$bus.$emit('rocket:ui:showToast', 'text', msg, 3);
            }
          });
      });
    },
    getNick() {
      const { nickApi } = this.cdkeyInfo;
      if (!nickApi) return;

      if (this.characterIDValue) {
        this.$axios
          .$get(nickApi, {
            params: { uid: this.characterIDValue },
          })
          .then((res) => {
            this.roleName = res.nick || '';
          })
          .catch(() => {
            this.roleName = '';
          });
      } else {
        this.roleName = '';
      }
    },
    preSubmit() {
      this.cdKeyParmas.character_id = this.characterIDValue;
      this.cdKeyParmas.gift_code = this.giftCodeValue;
      this.cdKeyParmas.verify_captcha_code = this.captchaCodeValue;

      this.errors = {
        character_id: '',
        gift_code: '',
        verify_captcha_code: '',
      };
      this.$nextTick(() => {
        if (!this.checkValidity()) return;
        this.showPopupConfirm = true;
      });
    },
  },
};
